import { Box, Text } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { ShopBadgeItemProps } from './ShopBadgeItem.types';

function ShopBadgeItem({
  text,
  variant,
  gradient,
  textColor,
  textGradient,
  // TODO: Fix TS
  backgroundColor,
  ...restBoxProps
}: ShopBadgeItemProps) {
  return (
    <Box
      padding="space-100"
      paddingLeft="space-200"
      borderTopRightRadius="radius-100"
      borderBottomRightRadius="radius-100"
      {...(variant === 'gradient'
        ? { variant, gradient }
        : { backgroundColor })}
      {...restBoxProps}
    >
      <Text
        variant="badge-semi"
        {...(textGradient ? { gradient: textGradient } : { color: textColor })}
      >
        {text.toUpperCase()}
      </Text>
    </Box>
  );
}

export default memo(ShopBadgeItem);
